<h2 mat-dialog-title>
  <mat-icon>refresh</mat-icon>
  Frigiv reserveret beløb
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <p>Er du sikker på, at du vil frigive det reserverede beløb for session {{ terminalSession.payterSessionId }}?</p>
  <p>
    Det reserverede beløb, som bliver frigivet er på
    <strong>{{ (terminalSession.reservedAmountInOere ?? 0) / 100 | dkCurrency }}</strong>
  </p>
  <p>Det reserverede beløb vil blive frigivet tilbage til kunden.</p>
  <button
    type="button"
    class="reserved-amount-button"
    mat-flat-button
    (click)="revertReservedAmount()"
    [disabled]="revertReservedAmountError">
    <mat-icon>refresh</mat-icon>
    <span>Frigiv reservationsbeløb</span>
  </button>

  @if (revertReservedAmountError) {
    <div [class.show]="revertReservedAmountError.show">
      <ok-feedback-info>
        <div>
          <p>Fejl detaljer:</p>
          <p class="error">
            {{ revertReservedAmountError.code }}
            {{ revertReservedAmountError.message }}
          </p>
        </div>
      </ok-feedback-info>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (terminalSession) {
    <div class="unit-identifier">
      <span>ChargingToken</span>
      {{ terminalSession.chargingToken }}
    </div>
  }

  <button class="actions__button" type="button" mat-dialog-close mat-flat-button color="primary" (click)="close()">Luk</button>
</mat-dialog-actions>
